<template lang="pug">
    v-form.c-form(autocomplete="off" @submit.prevent="submit")

        //  Name field
        v-text-field(
            :error-messages="errors.collect('fullName')"
            :data-vv-as="$t('fields.fullName')"
            :label="$t('fields.fullName')"
            name="fullName"
            v-model="model.fullName"
            v-validate="'required|min:2|max:72'"
            outline
        )

        // Email field
        v-text-field(
            name="email"
            :label="$t('fields.email')"
            type="email"
            v-model="model.email"
            v-validate="{ required: true, email: true }"
            :data-vv-as="$t('fields.email')"
            :error-messages="errors.collect('email')"
            browser-autocomplete="new-password"
            outline
        )

        // Password field
        v-text-field(
            name="password"
            :label="$t('fields.password')"
            v-model="model.password"
            v-validate="{ required: true, min: 6, max: 24, verify_password: true }"
            :data-vv-as="$t('fields.password')"
            :error-messages="errors.collect('password')"
            browser-autocomplete="new-password"
            outline
            ref="password"
            :append-icon="visibility ? 'visibility' : 'visibility_off'"
            @click:append="() => (visibility = !visibility)"
            :type="visibility ? 'text' : 'password'"
        )

        // Password Confirm field
        v-text-field(
            name="passwordConfirmation"
            v-model="model.passwordConfirmation"
            :label="$t('fields.confirm_password')"
            v-model.lazy="model.passwordConfirmation"
            v-validate="{ required: true, min: 6, max:24, is: model.password, verify_password: true }"
            :data-vv-as="$t('fields.confirm_password')"
            :error-messages="errors.collect('passwordConfirmation')"
            outline
            data-vv-as="Confirm Password"
            :append-icon="visibility ? 'visibility' : 'visibility_off'"
            @click:append="() => (visibility = !visibility)"
            :type="visibility ? 'text' : 'password'"
        )

        v-text-field(
            v-if="isUkrainePage"
            :label="$t('fields.country')"
            name="country"
            v-model="country"
            outline
        )

        template(v-if="customFields")
            div(v-for="field in customFields")
               v-select(
                   v-if="field.type === 'select'"
                   name="field.name"
                   append-icon="expand_more"
                   outline
                   v-model="model[field.name]"
                   :items="field.options"
                   :label="field.label"
               )

               v-text-field(
                   v-if="field.type === 'input'"
                   name="field.name"
                   v-model="model[field.name]"
                   :label="field.label"
               )

        div.text-center
            div

                // Submit button
                button-component.mx-0.mb-3.submit(
                    large
                    type="submit"
                    color="primary"
                    size="medium"
                    :action="submit"
                    :isLoading="isLoading"
                ) {{ $t('auth.registrationByBusiness.button') }}

            div.hint
                span {{ $t('auth.registrationByBusiness.bottomText') }}
</template>

<script>
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import { mapActions, mapGetters } from 'vuex';
    import VueTypes from 'vue-types';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        components: {
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        props: {
            businessId: VueTypes.string.def(''),
            customFields: VueTypes.array.def([]),
            isUkrainePage: VueTypes.bool.def(false)
        },
        data() {
            return {
                model: {
                    fullName: '',
                    email: '',
                    password: '',
                    passwordConfirmation: ''
                },
                country: '',
                visibility: false
            };
        },
        computed: {
            ...mapGetters('auth', ['isLoading'])
        },
        mounted() {
            // TODO: Refactor in all auth pages.
            const dict = {
                custom: {
                    fullName: {
                        required: 'Full Name field is required',
                        min: 'Your Full Name must be at least 2 characters.',
                        max:
                            'Your Full Name may not be greater than 72 characters'
                    },
                    email: {
                        email: 'Invalid Email',
                        required: 'Email field is required'
                    },
                    password: {
                        required: 'Password field is required',
                        min: 'Your Password must be at least 8 characters.',
                        max:
                            'Your Password may not be greater than 24 characters'
                    },
                    passwordConfirmation: {
                        required: 'Confirm Password field is required',
                        is: 'Oops! It looks like your Password doesn’t match.',
                        min: 'Your Password must be at least 8 characters.',
                        max:
                            'Your Password may not be greater than 24 characters'
                    }
                }
            };

            this.$validator.localize('en', dict);
        },
        methods: {
            ...mapActions('auth', ['registrationByBusiness']),

            /**
             * Create user and redirect to confirmation registration page
             */
            async submit() {
                const validation = await this.$validator.validateAll();
                if (!validation) return;
                if (this.isUkrainePage) this.model.country = this.country;

                this.registrationByBusiness({
                    ...this.model,
                    businessId: this.businessId
                });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .hint
        font-size: 12px
</style>
